<aside class="replace-action big-input-grid-with">
  <h4 class="to"><span>with</span></h4>
  <div id="replace-container" [ngClass]="exceededDestinationCharCount > 0 ? 'grid-2' : ''">
    <label [ngSwitch]="this.destinationTypeControl.value" class="other-operators">
      <input *ngSwitchCase="'STRING'" type="text" [formControl]="valueControl" placeholder="Empty string">
      <input *ngSwitchCase="'INTEGER'" type="number" [formControl]="valueControl" required>
      <input *ngSwitchCase="'DOUBLE'" type="number" [formControl]="valueControl" required>
      <input *ngSwitchCase="'FLOAT'" type="number" [formControl]="valueControl" required>
      <input *ngSwitchCase="'BIG_DECIMAL'" type="number" [formControl]="valueControl" required>
      <div *ngSwitchCase="'DATE'" class="datepicker-container">
        <input matInput
               [matDatepicker]="picker_date_criteria"
               placeholder="dd/mm/yyyy"
               (click)="picker_date_criteria.open()"
               [formControl]="valueControl"
               max="9999-12-31"
               required>

        <mat-datepicker-toggle matSuffix [for]="picker_date_criteria"></mat-datepicker-toggle>
        <mat-datepicker #picker_date_criteria></mat-datepicker>
      </div>
      <input *ngSwitchCase="'BOOLEAN'" [checked]="valueControl.value" class="kyloe-checkbox" type="checkbox" [formControl]="valueControl">
      <input *ngSwitchDefault type="text" disabled placeholder="No field selected">
    </label>
    <span *ngIf="exceededDestinationCharCount > 0" class="material-icons notranslate tooltip-icon danger"
          matTooltip="Note: You have exceeded the destination fields maximum length by {{exceededDestinationCharCount}} character(s). Excess will be truncated."
          matTooltipClass="mat-tooltip">error_outline</span>
  </div>
</aside>
